export enum Category {
  News = "お知らせ",
  Event = "イベント",
  Announcement = "お知らせ",
  Media = "メディア掲載",
}

export class Article {
  id: number = 0;
  title: string = "";
  updatedAt: string = "";
  body?: string = "";
  image?: string = "";
  category: Category | null = null;
  href?: string = "";
  revealAt?: number = 0;

  constructor(params?: Partial<Article>) {
    Object.assign(this, params);
  }
}

export default class NewsArticles {
  static all: Article[] = [
    {
      id: 1,
      category: Category.News,
      title:
        "WEB上で面接が出来るクラウド型システムiM（interview maker/インタビューメーカー）をリリース",
      updatedAt: "2016/06/05",
    },
    {
      id: 2,
      category: Category.News,
      title:
        "東急ハンズがスマホで撮影した動画で採用を決める 「録画面接」を開始",
      updatedAt: "2017/07/01",
      href: "https://www.atpress.ne.jp/news/131689",
    },
    {
      id: 3,
      category: Category.News,
      title: "面接情報サイト「Interview maker's magazine」を公開",
      updatedAt: "2017/07/01",
      href: "https://interview-maker.jp/magazine/",
    },
    {
      id: 4,
      category: Category.Media,
      title: "「Business Journal」でインタビューメーカー導入事例を掲載",
      updatedAt: "2017/10/01",
      href: "https://biz-journal.jp/2017/11/post_21189.html",
    },
    {
      id: 5,
      category: Category.Media,
      title: "「輸送新聞」でインタビューメーカーが紹介",
      updatedAt: "2017/10/01",
    },
    {
      id: 6,
      category: Category.Media,
      title: "「くらしのトピック」でインタビューメーカーが紹介",
      updatedAt: "2017/11/01",
      href: "https://kurashi-no-topic.com/business-career/11363/",
    },
    {
      id: 7,
      category: Category.News,
      title: "関西HRエキスポでインタビューメーカーのブースを出展",
      updatedAt: "2017/11/01",
    },
    {
      id: 8,
      category: Category.Media,
      title:
        "MBS（毎日放送）情報番組「VOICE」でインタビューメーカーの紹介を放送",
      updatedAt: "2017/11/01",
      href: "https://www.mbs.jp/voice/special/archive/20171124/",
    },
    {
      id: 9,
      category: Category.Media,
      title:
        "日経Smart Workプロジェクト『働き方改革』広告内で日経新聞にブルーエージェンシーが掲載",
      updatedAt: "2017/11/01",
    },
    {
      id: 10,
      category: Category.News,
      title: "日経Smart Workプロジェクト『働き方改革』セミナーで講演",
      updatedAt: "2017/11/01",
      href: "http://adnet.nikkei.co.jp/e/event.asp?e=02686",
    },
    {
      id: 11,
      category: Category.Media,
      title: "「東洋経済オンライン」でインタビューメーカーが紹介",
      updatedAt: "2017/12/01",
      href: "https://toyokeizai.net/articles/-/200501",
    },
    {
      id: 12,
      category: Category.News,
      title: "インタビューメーカー公式キャラクターに内田恭子さん就任",
      image: require("@/assets/images/news/news_001/image1.png"),
      updatedAt: "2018/09/03",
      body: `
        フリーキャスター内田恭子さんとプロモーションにおける年間契約を締結し、9月より内田恭子さんが出演するプロモーション動画の配信を開始いたしました。
        <br>
        内田さんは、インタビューメーカーの導入に関する説明動画や、弊社の採用担当面接官として動画に登場する他、年間を通じて人事採用イベントに出演いたします。
        <br><br>
        <a href="/release-pdf/release_blueagency_20180903.pdf" target="_blank">報道発表資料</a>
      `,
    },
    {
      id: 13,
      category: Category.News,
      title: "「HRアワード2018」プロフェッショナル部門にノミネートされました",
      updatedAt: "2018/09/10",
      href: "http://hr-award.jp/nominate3.php#3-20",
    },
    {
      id: 14,
      category: Category.Media,
      title: "bizpowに前田のインタビューが掲載されました",
      updatedAt: "2018/11/14",
      href: "https://bizpow.bizocean.jp/edge/blueagency/",
    },
    {
      id: 15,
      category: Category.Media,
      title: "TBSテレビ「NEWS23」に、インタビューメーカーが取り上げられました",
      image: require("@/assets/images/news/news_003/image2.png"),
      updatedAt: "2018/11/13",
      body: `
        弊社サービス「インタビューメーカー」が、2018年11月13日の<a href="https://www.tbs.co.jp/news23/onair/" target="_blank">TBSテレビ「NEWS23」</a>に取り上げられました。
      `,
    },
    {
      id: 16,
      category: Category.News,
      title: "「Game Changer 2019」に前田が選出されました",
      updatedAt: "2019/01/07",
      href: "https://www.businessinsider.jp/beyondmillennials/vote.html",
    },
    {
      id: 17,
      category: Category.News,
      title: "第1回 名古屋HR EXPOに出展しました",
      updatedAt: "2019/01/22",
      href: "https://www.hr-expo.jp/ja-jp/visit/nagoya.html",
    },
    {
      id: 18,
      category: Category.News,
      title: "【インタビューメーカー】宮崎県日南市と地方創生事業で提携",
      image: require("@/assets/images/news/news_004/image3.png"),
      updatedAt: "2019/01/31",
      body: `
        弊社は、宮崎県日南市と地方創生事業において協定を締結、1月31日に協定締結式を実施いたしました。
        <br><br>
        現在、日南市では、少子高齢化や若者の流出等による人口減少と、市内中小企業の人手不足が深刻化しています。
        <br>
        その対策のひとつとして、時間や場所に関わらず利用でき移住希望者の利便性が高い「インタビューメーカー」の導入に至りました。自治体への導入は初となります。
        <br>
        日南市は、「インタビューメーカー」で移住希望者の相談・サポート体制の充実を図るとともに、移住希望者と市内企業をオンラインで繋ぐことで、移住の促進及び市内企業の人材確保に繋げることを目的としています。
        <br>
        <br>
        <a href="/release-pdf/fl1902041403483.pdf" target="_blank">報道発表資料</a>
      `,
    },
    {
      id: 19,
      category: Category.News,
      title: "【全社】名古屋進出が決定しました",
      updatedAt: "2019/04/01",
      body: `
        東京、大阪に続いて、名古屋にも新しくオフィスを構えることが決定しました。
        <br><br>
        名古屋支社
        <br>
        〒453-6190 愛知県名古屋市中村区
        <br>
        平池町4-60-12 グローバルゲート名古屋
      `,
    },
    {
      id: 20,
      category: Category.News,
      title: "株式会社スタジアムが5.6億円の資金調達を実施しました",
      updatedAt: "2019/05/28",
      image: require("@/pr-assets/20190528_im.png"),
      body: `
        <p>
        ウェブ面接「インタビューメーカー」をSaaS形式で提供する株式会社スタジアム（本社：東京都港区、代表取締役：太田靖宏）は、ジャフコ（本社：東京都港区、取締役社長：豊貴 伸一）を引受先とした5億6,000万円の第三者割当増資を実施いたしました。
        <p>
        <br>
        <a href="/release-pdf/20190528.pdf" target="_blank">報道発表資料はこちら(PDF)</a>
        <br>

        <h2>「インタビューメーカー」の事業について</h2>

        <p>
        当社は、スマホやPCがあればいつでもどこでも面接ができる月額制のウェブ面接ツール「インタビューメーカー」をSaaS形式で提供しています。2017年5月のサービス開始以来、株式会社ADKホールディングス様、株式会社コーセー様、積水ハウス株式会社様、キユーピー株式会社様、ダイドードリンコ株式会社様を始めとする1,100社以上の企業に導入されるサービスに成長いたしました。
        (<a href="https://interview-maker.jp/case/" target="_blank">導入事例はこちらより</a>ご参照いただけます。)
        </p>
        <p>
        導入企業様には、採用工数やコストの削減が図れる、録画面接で24時間応募に対応できる、遠隔地などこれまで接点のなかった応募者数を増やせるなどの点で好評をいただいております。求職者に対してはより広い面接機会を、企業や市町村に対しては採用力を提供するSaaSです。
        (<a href="/news/18" target="_blank">宮崎県日南市様との地方創生事業の協定締結に関しての詳細はこちら</a>からご参照いただけます。)
        </p>
        <p>
        現在の就職市場は、求人倍率が1.63倍（2018年12月時点、厚生労働省統計）と超売り手市場です。人材難が続いており、企業からは採用に関してのソリューションが求められています。そんな中、求人メディアなど採用手段や採用管理については「HRTech」と呼ばれるITの活用が進みました。
        </p>
        <p>
        しかし面接自体に関してはテクノロジーによる進化がほとんどなされておらず、未だ採用担当者の属人的要素が多くを占めるのが実情です。我々は、「インタビューメーカー」によって、面接にテクノロジーを導入し、旧態依然とした面接を進化させていきます。
        </p>
        <p>
        また企業が求職者をジャッジするだけの画一的な面接ではなく、双方が面接の意義と出会いの楽しみを感じられる「新しい面接」を社会に提案していければと思っています。
        </p>

        <h2>面接 × テクノロジーとは</h2>

        <p>面接がオンライン化することで、時間や場所にとらわれずに企業と応募者は対話が可能になりました。私たちは、面接とテクノロジーの融合をさらに進め、従来では得られなかった価値や気づきを面接参加者に提供し、その利便性も大幅に高めていきます。</p>
        <p>例えば、応募者の発言内容や表情の変化などの録画データを解析することで、応募者の特性や性格をより深く、丁寧に知ることが可能になります。これにより、会社文化とのマッチング度合いを早い段階で把握し、入社後の活躍を推し量ることを支援します。</p>
        <p>また面接中にとどまらず、面接実施前、面接実施後と選考プロセス全体にテクノロジーの適用範囲を広げることで、さらなる大きな変革を目指します</p>
        <p>まずは弊社が保有する7万件を超える面接データの解析を進め、第一弾となる機能をリリースする予定です。</p>

        <h2>資金調達の目的</h2>
        <p>今回調達した資金の利用目的は以下の通りです。</p>
        <ol>
          <li>採用面接映像データのAI解析や、インタビューメーカーの機能開発。</li>
          <li>エンジニア職・営業職を中心とする人材採用。</li>
          <li>マーケティング・プロモーション活動。</li>
          <li>シンガポール拠点設立による、グローバル展開の始動</li>
        </ol>

        <h2>株式会社ジャフコ　取締役　パートナー　三好啓介様からのコメント</h2>
        <p>人材と雇用は規模や業種に関わらず、企業の最重要課題となっており、それに伴い、採用手法はWebを基盤にテクノロジーの進化に合わせて、大きく変化していくでしょう。スタジアムには、人材領域を熟知した太田社長のもと、様々なバックグラウンドを持つ強力な経営陣とメンバーが結集しています。「インタビューメーカー」は、企業の採用シーンを塗り替える事業になると期待しています。</p>
        <br><br>
        <a href="/release-pdf/20190528.pdf" target="_blank">報道発表資料はこちら(PDF)</a>
        <br><br><br>
        <p class="no-indent">
        お問い合わせ先:<br>
        株式会社スタジアム​　広報担当: 前田<br>
        TEL: <a href="tel:0357977179">03-5797-7179</a>, 携帯: <a href="tel:08047350088">080-4735-0088</a><br>
        Mail: <a href="mailto:pr@stadium.co.jp">pr@stadium.co.jp</a>
        </p>
      `,
    },
    {
      id: 21,
      category: Category.Media,
      updatedAt: "2019/05/28",
      title:
        "TechCrunch に記事が掲載されました: 「ITで“面接の近代化”へ、約1100社が使うウェブ面接ツール開発のスタジアムが5.6億円を調達」",
      href: "https://jp.techcrunch.com/2019/05/28/stadium-fundraising/",
    },
    {
      id: 22,
      category: Category.News,
      title: "第7回 HR EXPOに出展しています",
      updatedAt: "2019/05/29",
      image: require("@/pr-assets/20190513-west2-2.png"),
      body: `
      <h2>第7回 HR EXPOに出展しています</h2>
      <p>東京ビッグサイトにて、5月29日〜5月31日の会期で開催中の<a href="https://www.hr-expo.jp/ja-jp.html" target="_blank">第7回 HR EXPO</a>に出展しています。
      <br>
      ブースでは、日本最大の導入企業数を誇る弊社サービス「<a href="https://interview-maker.jp/" target="_blank">インタビューメーカー</a>」を実際にご体験いただけます。
      <br>
      西2ホールの出入り口すぐ(A9-19)ですので、是非お立ち寄りください。
      </p>
      `,
    },
    {
      id: 23,
      category: Category.News,
      title:
        "〜HRテックが繋がる時代〜 Web面接サービス『インタビューメーカー』が周辺サービス11社と連携へ ",
      updatedAt: "2019/07/12",
      image: require("@/pr-assets/hr-goes-next-gen.jpg"),
      body: `
      <p>Web面接市場を牽引する株式会社スタジアム（本社 東京都港区、代表取締役社長 CEO 太田 靖宏）は、ATS（採用管理システム）や求人メディア等のHRテック企業との連携・協業を進めます。</p>
      <br />
      <a href="/release-pdf/hrtech-goes-next-generation.pdf" target="_blank">報道発表資料はこちら(PDF)</a>
      <br />
      本件に関するお問い合わせは<a href="/contact" target="_blank">こちらから</a>お願いします。
      </p>

      <h2>採用活動を行う企業の為にHRテック企業との連携</h2>
      <p>採用難時代が続く中で、多様化する採用チャネルやツールを使いこなす為に、企業は更なる負担を強いられています。当社は採用活動を行う企業やユーザー（応募者）が、よりストレス無く採用活動に熱中できる事を目的として、続々と登場するHRテック企業との連携を実現します。<br />例：面接中にペーパーに評価を書くのではなく、Web面接を行いながら評価シートを同画面で入力、面接録画を保存など、効率的で質の高い面接の場を提供。</p>
      <p>当社は今後、連携する為のAPI仕様を公開し、他のHR関連サービスにおいても、Web面接サービスとして国内最大級の導入企業数を誇る当社のWeb面接技術を広くご利用いただけるようにしていきます。それによって採用活動を行う企業へ、様々なツールを今までよりも低いハードルで導入・活用できる環境を提供します。</p>
      <h2>連携予定企業11社</h2>
      <p>イグナイトアイ株式会社（SONAR）、株式会社ウィルビー（JobMaker）、株式会社ゼクウ（RPM）、 株式会社ステラス（ジョブスイート）、株式会社天職市場（テンリク）、 株式会社ネオキャリア（MOCHICA）、 パーソルプロセス＆テクノロジー株式会社（HITO-Link リクルーティング）、株式会社HERP（HERP ATS）、 株式会社ブレイン・ラボ（CAREER PLAS）、株式会社リアライブ（Reworks Cloud）、株式会社リフカム（Refcome）<br />引き続き、連携企業を増やして参ります。</p>
      <h2>既にイグナイトアイ株式会社（SONAR）とは連携がスタート</h2>
      <p>インタビューメーカー×API連携の最大のメリットは「採用フローにWeb面接を組み込むことが容易になる」こと。応募者が面接日を選択するだけで日程が予約されるので、面接官が行う準備は特段ございません。</p>
      <p>既に実運用している企業様がいらっしゃいます。総合デベロッパーである野村不動産株式会社様は、当社が採用管理システムのSONARと連携することが決め手となり、インタビューメーカーをご導入いただきました。<br />新卒採用で地方学生を対象にWeb面接を実施され、大変ご満足いただいております。<br />インタビューメーカー×SONAR連携により、あらゆる採用業務をシームレスに行うことが出来る為、より効率的な採用業務とWeb面接を活用した地方学生との接点創出を実現いたしました。</p>

      <h2>『インタビューメーカー』について</h2>
      <p>当社は、スマホやPCがあればいつでもどこでも面接ができる月額制のWeb面接ツール「インタビューメーカー」をSaaS形式で提供しています。<br />2017年5月のサービス開始以来、株式会社ADKホールディングス様、株式会社コーセー様、積水ハウス株式会社様、キユーピー株式会社様、ダイドードリンコ株式会社様を始めとする1,100社以上の企業に導入されるサービスに成長いたしました。<br />導入企業様には、採用工数やコストの削減が図れる、録画面接で24時間応募に対応できる、遠隔地などこれまで接点のなかった応募者を増やせるなどの点で好評をいただいております。<br />求職者に対してはより広い面接機会を、企業や市町村に対しては採用力を提供するSaaSです。
      </p>
      <h2>株式会社スタジアムについて</h2>
      <p>スタジアムという会社名には、「チームで熱中する場所」という意味が込められています。<br />個の力だけでは成し遂げられないような事でも、チームで熱中し取り組むからこそ、できることがあります。<br />まずは、一歩を踏み出す。踏み出したら、限界を決めずに、人のため、信じて進み続ける。<br />やがて、その一歩が、社会を変える大きな足跡となっていく。<br />スタジアムは、チームで熱中し、不可能を可能にすることが、未来のライフスタイルを変えると信じています。
      <br /><br /><br />
      本件に関するお問い合わせは<a href="/contact" target="_blank">こちらから</a>お願いします。
      </p>
      `,
    },
    {
      id: 24,
      revealAt: 1563415200, // 2019/7/18 11:00
      category: Category.News,
      title:
        "Web・録画面接「インタビューメーカー」提供のスタジアムがリクルートマネジメントソリューションズと業務提携",
      updatedAt: "2019/07/18",
      image: require("@/pr-assets/20190718-stadium-rms.jpg"),
      body: `
      <p>Web・録画面接システム導入社数1,100社突破の「インタビューメーカー」を提供する株式会社スタジアム（東京都港区、代表取締役：太田 靖宏）は、株式会社リクルートマネジメントソリューションズ（東京都品川区、代表取締役社長：藤島 敬太郎）と業務提携をいたしました。</p>
      <p>両社が培ってきた、採用面接と適性検査のデータやノウハウを連携させることで、企業と個人のマッチング精度を高め、新しい出会いの創出を目指します。</p>
      <br />
      <a href="/release-pdf/20190718_stdium_rms.pdf" target="_blank">報道発表資料はこちら(PDF)</a>
      <br />
      本件に関するお問い合わせは<a href="/contact" target="_blank">こちらから</a>お願いします。
      </p>

      <h2>業務提携の概要</h2>
      <p>スタジアム社の持つ録画面接データと、リクルートマネジメントソリューションズ社の持つ応募者の適性検査を組み合わせ、ブラックボックス化していた「面接」活動に、テクノロジーや科学的アプローチを導入していきます</p>

      <h2>業務提携をする目的</h2>
      <ul>
        <li>面接の業務効率改善とパフォーマンス改善をもたらす支援サービスを開発することで、応募者と面接者双方にとって納得感の高い面接機会を創出</li>
        <li>録画面接解析データを共同研究し、対面面接への依存を軽減できる新しい人材アセスメントサービスを開発</li>
      </ul>

      <h2>第一弾の「インタビューメーカー」と「SPI３」連携は、8月よりスタート</h2>
      <p>提携の第一弾として、2019年8月1日より、「インタビューメーカー」とリクルートマネジメントソリューションズが提供するシェアナンバー１の*適性検査「SPI3」のシステム連携を行います。
        <br />（*年間13,200社※１、202万人の受検者数※2。)
        <br />※1「適性検査利用調査」2018年9月実施調査実施機関:株式会社クロス･マーケティング
        <br />※2 2018年度実績
      </p>

      <p>本連携により、応募者の適性検査結果を確認しながらWeb面接を行えるようになり、人材の見極めがスムーズになります。加えて、従来多くの企業が面接時に印刷していた履歴書やSPI3の結果が、インタビューメーカー上で確認できるようになるため、採用面接のペーパレス化も促進されます。</p>

      <p>インタビューメーカーとSPI3を契約中の企業は、インタビューメーカー上で応募者に対してSPI3の受検を依頼し、結果を確認しながらWeb面接をすることができます。連携にあたる追加費用は不要。スタジアム社への申込のみで連携が開始します。
        <br />※　SPI3のうち、「Web-SPI：Web無登録方式」の利用企業様が対象となります
        <br />※　「カスタマイズ項目あり」の検査については、現在対応しておりません
      </p>

      <h2>業務提携を両社が目指した背景</h2>
      <p>現在の就職市場は、求人倍率が1.63倍（2018年12月時点、厚生労働省統計）と依然として超売り手市場が継続。採用に苦戦する企業が増えています。採用手法は多様化し、人事領域のテクノロジーが進んでいますが、採用面接自体は面接者の属人的な要素が強く、企業と個人のマッチングシーンは長らくブラックボックスになっていました。</p>
      <p>Web面接と業界ナンバーワンの適性検査のサービスと技術を連携させることにより、面接シーンの可視化と共に、テクノロジーによる面接の質の向上が期待できます。</p>
      <p>両社のサービスが連携することで、企業は、スピーディかつ適切な人材の見極めを行えるようになり採用効率が向上します。また応募者にとっても、自身の力を最大限発揮できる機会との出会いの増加に繋がります。</p>

      <h2>業務提携の今後の展開について</h2>

      <p>両社の培ってきた人事・採用面接に関わるデータと強みを活用し、新サービスを開発していく予定です。現在検討している協働テーマは下記の通りです。</p>

      <h3>１）リクルートマネジメントソリューションズが提供する「面接力向上サービス」の強化</h3>
      <p>インタビューメーカーは、Web面接終了後に応募者から面接満足度を取得しています。このアンケートの結果を、リクルートマネジメントソリューションズが提供している「面接者トレーニング」等に活かすことや、面接者の習熟度測定が可能になります。これにより、面接者の習熟スピードの改善や面接そのものの質向上が期待できます。</p>

      <h3>２）面接の録画データと「SPI3」の連携による応募者評価サービスの開発</h3>

      <p>インタビューメーカーは、リアルタイムにWeb上で面接官とやり取りをするWeb面接を録画し蓄積するだけでなく、設問に対する回答を動画で提出することで24時間選考ができる録画面接も提供しています。</p>
      <p>面接の録画データからは、応募者の第一印象、話し方、志望度の高さなど多くの情報が得られるため、エントリーシートの代用として採用フローに導入する企業も増加しております。スタジアム社では、現在、面接の録画データの解析を進めています。</p>
      <p>面接の録画によって得られる応募者の印象データと、「SPI3」による適性検査の結果を組み合わせることにより、企業は応募者と対面する前に精度の高い一次評価ができるようになったり、加えて、面接の録画データとSPI3の情報を統合することにより面接における人物理解が深まることも期待できます。この連携は、採用の効率アップだけでなく、応募者と企業の不幸なマッチングを防ぐことにも繋がり、個人と企業のより良い出会いの創出につながります。</p>

      <h2>株式会社リクルートマネジメントソリューションズ 執行役員 山崎 淳様 からのコメント</h2>
      <p>採用活動における「面接」は、これまでブラックボックスであることが普通でした。両社ならではの知見を活かし、「面接」にイノベーションを起こしていくことを期待しています。そのことで、採用活動を行う企業にとっても、求職者にとっても効率的・効果的な活動になることを狙います。</p>

      <h2>株式会社スタジアム 執行役員 前澤 隆一郎 からのコメント</h2>

      <p>私たちは、「面接×テクノロジー」を掲げ、従来では得られなかった価値や気づきを面接参加者に提供し、その利便性も大幅に高めることを目指しています。今回の業務提携は、まさに面接が、テクノロジーを介して「適性検査」と融合することで新たな価値の創出につながる大きな一歩になると考えています。業界最大手のリクルートマネジメントソリューションズ様の持つ技術や知見を組み合わせることで、応募者と企業の双方にとって意義のあるサービスを両社で提供できるものと信じております。</p>

      <h2>『インタビューメーカー』について</h2>
      <p>当社は、スマホやPCがあればいつでもどこでも面接ができる月額制のWeb面接ツール「インタビューメーカー」をSaaS形式で提供しています。<br />2017年5月のサービス開始以来、株式会社ADKホールディングス様、株式会社コーセー様、積水ハウス株式会社様、キユーピー株式会社様、ダイドードリンコ株式会社様を始めとする1,100社以上の企業に導入されるサービスに成長いたしました。<br />導入企業様には、採用工数やコストの削減が図れる、録画面接で24時間応募に対応できる、遠隔地などこれまで接点のなかった応募者を増やせるなどの点で好評をいただいております。<br />求職者に対してはより広い面接機会を、企業や市町村に対しては採用力を提供するSaaSです。
      </p>
      <h2>株式会社スタジアムについて</h2>
      <p>スタジアムという会社名には、「チームで熱中する場所」という意味が込められています。<br />個の力だけでは成し遂げられないような事でも、チームで熱中し取り組むからこそ、できることがあります。<br />まずは、一歩を踏み出す。踏み出したら、限界を決めずに、人のため、信じて進み続ける。<br />やがて、その一歩が、社会を変える大きな足跡となっていく。<br />スタジアムは、チームで熱中し、不可能を可能にすることが、未来のライフスタイルを変えると信じています。
      <br /><br /><br />
      本件に関するお問い合わせは<a href="/contact" target="_blank">こちらから</a>お願いします。
      </p>
      `,
    },
    {
      id: 25,
      category: Category.Media,
      updatedAt: "2019/10/01",
      title:
        "「インタビューメーカー」が公開した法人向けビデオ通話サービスのカオスマップがTechcrunchに掲載",
      href:
        "https://jp.techcrunch.com/2019/10/01/stadium-video-chat-services-chaos-map/",
    },
    {
      id: 26,
      category: Category.News,
      updatedAt: "2019/10/21",
      title:
        "「インタビューメーカー」が、面接データの自動文字起こし「iM アシスタント」の提供を開始",
      href: "https://prtimes.jp/main/html/rd/p/000000018.000015527.html",
    },
    {
      id: 27,
      category: Category.Media,
      updatedAt: "2019/10/30",
      title:
        "マイナビAgent「スタートアップ企業特集」に代表の太田のインタビューが掲載",
      href: "https://mynavi-agent.jp/helpful/startup/category_it/stadium.html",
    },
    {
      id: 28,
      category: Category.News,
      updatedAt: "2019/11/05",
      title: "関西HR Expo(11/13-15)に、「インタビューメーカー」が出展",
      href:
        "https://www.office-kansai.jp/ja-jp/about/hr.html?rf=about_hr&act=kansai_hr",
    },
    {
      id: 29,
      category: Category.News,
      updatedAt: "2019/11/13",
      title:
        "「インタビューメーカー」が、次世代面接システム「iM」のコンセプトサイトをオープン",
      href: "https://im.interview-maker.jp/",
    },
    {
      id: 30,
      category: Category.News,
      updatedAt: "2019/12/11",
      title:
        "【面接開始まで求職者は平均6分待ちぼうけ】インタビューメーカー、面接待機時間を活用した会社紹介動画サービス開始へ",
      href: "https://prtimes.jp/main/html/rd/p/000000019.000015527.html",
    },
    {
      id: 31,
      category: Category.News,
      updatedAt: "2019/12/19",
      title: "クラウド型面接官研修「iｍトレーナー」をリリース",
      href: "https://prtimes.jp/main/html/rd/p/000000020.000015527.html",
    },
    {
      id: 32,
      category: Category.Media,
      updatedAt: "2019/12/19",
      title: "TechCrunchにて「imトレーナー」が記事化されました！",
      href:
        "https://jp.techcrunch.com/2019/12/19/imtrainer/?fbclid=IwAR2V-VtmwTnB4KyDMFsRH9asuhlAlsAddrLRP4yfmaYtN6N8IhCg8DIArZE",
    },
    {
      id: 33,
      category: Category.News,
      updatedAt: "2020/01/18",
      title: "「Chromium版Edge」によるオンライン面接の提供をスタート",
      href: "https://prtimes.jp/main/html/rd/p/000000021.000015527.html",
    },
    {
      id: 34,
      category: Category.News,
      updatedAt: "2020/01/21",
      title:
        "寝屋川市役所「窓口改革室」職員選考に、インタビューメーカーを録画面接システムとして導入",
      href: "https://prtimes.jp/main/html/rd/p/000000023.000015527.html",
    },
    {
      id: 35,
      category: Category.News,
      updatedAt: "2020/01/28",
      title: "沖縄県宜野座村と提携し締結式を実施しました",
      href: "https://prtimes.jp/main/html/rd/p/000000024.000015527.html",
    },
    {
      id: 36,
      category: Category.News,
      updatedAt: "2020/01/28",
      title:
        "新型コロナウイルスの感染拡大による出社・来社困難に備えた、「インタビューメーカー」無償提供を開始しました",
      body: `
        <p>
        Web面接・録画面接システム導入社数1,100社突破の「インタビューメーカー」を提供する株式会社スタジアム（東京都港区、代表取締役：太田 靖宏）は、新型コロナウイルスの感染拡大に伴い、現在採用活動を行っている企業向けに、非対面で面接が可能になるオンライン面接ツール「インタビューメーカー」の無償提供を行います。
        </p>
        <p>
        　新卒採用は、2月から本格シーズンを向かえます。しかし、新型のコロナウイルスの感染拡大に伴い、一部の企業は在宅勤務への切り替えを実施するなど、外出の影響への懸念が広がっています。
        </p>
        <p>
        当社では、「いつでも・どこでも」面接実施可能なオンライン面接の強みを最大限活かし、各企業の選考活動がコロナウイルスの懸念によって滞ることないように支援するとともに、就活生など求職中の皆さまと、各企業で働かれる従業員の皆さまに安心安全な面接環境を1つでも多く提供できるように、サービスの無償開放を実施することになりました。
        </p>
        <p class="no-indent">
        ■詳細は<a href="https://prtimes.jp/main/html/rd/p/000000025.000015527.html" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 37,
      category: Category.Media,
      updatedAt: "2020/02/03",
      title:
        "Business Insiderで「インタビューメーカー」無償提供開始についての記事が掲載されました",
      href: "https://www.businessinsider.jp/post-206775",
    },
    {
      id: 38,
      category: Category.Media,
      updatedAt: "2020/02/05",
      title: "日経新聞で「imトレーナー」が紹介されました",
      href:
        "https://r.nikkei.com/article/DGKKZO55219170U0A200C2EA1000?unlock=1&s=4",
    },
    {
      id: 39,
      category: Category.News,
      updatedAt: "2020/02/10",
      title:
        "新型コロナウイルスの感染拡大に伴う選考・採用活動への影響調査をプレスリリースしました",
      href: "https://prtimes.jp/main/html/rd/p/000000026.000015527.html",
    },
    {
      id: 40,
      category: Category.Media,
      updatedAt: "2020/02/12",
      title: "日経ビジネスにて、im無償提供の取り組みを紹介いただきました",
      href: "https://business.nikkei.com/atcl/NBD/19/depth/00510/",
    },
    {
      id: 41,
      category: Category.Media,
      updatedAt: "2020/02/13",
      title: "テレ東ニュースにて、im無償提供の取り組みを紹介いただきました",
      href: "https://txbiz.tv-tokyo.co.jp/txn/news_txn/post_196450/",
    },
    {
      id: 42,
      category: Category.Media,
      updatedAt: "2020/02/14",
      title:
        "テレビ朝日「スーパーJチャンネル」で、im無償提供の取り組みを紹介いただきました",
    },
    {
      id: 43,
      category: Category.Media,
      updatedAt: "2020/02/17",
      title:
        "産経新聞とフジサンケイビジネスアイにて、im無償提供の取り組みを紹介いただきました",
      href: "https://www.sankei.com/economy/news/200216/ecn2002160003-n1.html",
    },
    {
      id: 44,
      category: Category.Media,
      updatedAt: "2020/02/19",
      title:
        "テレビ朝日「モーニングショー」にて、im無償提供の取り組みを紹介いただきました",
    },
    {
      id: 45,
      category: Category.Media,
      updatedAt: "2020/02/19",
      title:
        "フジテレビ「Live News days」にて、im無償提供の取り組みを紹介いただきました",
    },
    {
      id: 46,
      category: Category.News,
      updatedAt: "2020/02/20",
      title:
        "新型コロナウイルス対応第二弾。最大8名まで対応の説明会やグループ面接機能の無償開放も開始",
      href: "https://prtimes.jp/main/html/rd/p/000000027.000015527.html",
    },
    {
      id: 47,
      category: Category.Media,
      updatedAt: "2020/02/21",
      title: "毎日新聞で、im無償提供の取り組みを紹介いただきました",
      href: "https://mainichi.jp/articles/20200220/k00/00m/040/344000c",
    },
    {
      id: 48,
      category: Category.Media,
      updatedAt: "2020/02/21",
      title: "NHK首都圏版ニュースで、im無償提供の取り組みを紹介いただきました",
      href: "https://www3.nhk.or.jp/shutoken-news/20200221/1000044421.html",
    },
    {
      id: 49,
      category: Category.News,
      updatedAt: "2020/02/21",
      title:
        "日本マーケティングリサーチ機構の調査で、満足度調査5部門でNo.1になりました",
      href: "https://prtimes.jp/main/html/rd/p/000000314.000033417.html",
    },
    {
      id: 50,
      category: Category.Media,
      updatedAt: "2020/02/21",
      title: "読売新聞に、オンライン面接についての当社コメントが掲載されました",
    },
    {
      id: 51,
      category: Category.News,
      updatedAt: "2020/02/25",
      title:
        "オンライン面接システム「インタビューメーカー」、インハウスAI動画編集クラウド「VIDEO BRAIN」と連携",
      image: require("@/pr-assets/20200225/im_videobrain.png"),
      body: `
        <p>Web面接・録画面接システム「インタビューメーカー」を提供する株式会社スタジアム（東京都港区、代表取締役：太田 靖宏）は、インハウスAI動画編集クラウド「VIDEO BRAIN」(ビデオブレイン)を提供する株式会社オープンエイト（東京都渋谷区、代表取締役社長 兼 CEO：髙松 雄康）と、両社の持つSaaS型サービスを組み合わせ、企業がリッチな採用コンテンツを作成し、オンラインで会社説明会を開催できるソリューションの共同提案を進めることとなりました。</p>
        <p class="no-indent">
          <a href="/release-pdf/20200225_im_VIDEOBRAIN.pdf" target="_blank">報道発表資料はこちら(PDF)</a><br />
        </p>
        <p>昨今、オンラインでの説明会のニーズが急速に高まっていますが、オンラインの選考活動で用いるコンテンツやインフラサービスを揃えることに課題を感じている企業は少なくありません。</p>
        <p>そこで、当社は、2020年1月28日より、1対1用のオンライン面接の機能を無償開放し、また、2020年2月20日からは、グループ面接・説明会機能を追加で無償開放することで、各社のオンライン化を支援してきました。</p>
        <p>今回、当社の取り組みに、オープンエイト社を迎え、会社説明会動画など採用におけるコンテンツ準備に悩む企業に対し、AIのサポートで誰でも簡単にクオリティの高い動画を作成することができるソリューション「VIDEO BRAIN」と「インタビューメーカー」を組み合わせて活用するソリューションの提供を開始致します。</p>
        <p>これまで企業紹介動画などは広告代理店や制作会社へ外注し数十万円から数百万円のコストと1ヶ月程度の時間をかけて制作することが主でしたが、クラウドサービスを活用することで人事担当者が手持ちの素材で動画を作成できるようになり、面倒だったオリエンやクリエイティブチェックから開放され、コストも時間も解決されます。定額制で作成上限の無い「VIDEO BRAIN」を活用すれば、コストを気にすること無く、あらゆる採用ポジションに向けた動画をいつでも何本でも多数作成することができ採用コンテンツの拡充を図れます。</p>
        <figure style="margin-top: 1em; margin-bottom: 1em;">
          <figcaption style="font-size: smaller;">（「VIDEO BRAIN」によって作成できる動画コンテンツイメージ）</figcaption>
          <video src='${require("@/pr-assets/20200225/video-open8_finalized.mp4")}' controls style="width: 100%;">
            <img src='${require("@/pr-assets/20200225/open8_2.png")}' alt="" style="max-width: 470px;" />
            <img src='${require("@/pr-assets/20200225/open8_3.png")}' alt="" style="max-width: 470px;" />
          </video>
        </figure>
        <p>「インタビューメーカー」と合わせて活用することで、オンライン説明会などで求職者に対して動画によるリッチなコミュニケーションを行うことができ、企業への理解の促進や応募意向を高めることが期待できます。</p>
        <p>SaaS事業者である両社がタッグを組むことで、企業のオンライン選考活動への支援を通じて優秀な人材を迅速に採用し企業の成長スピードを高めることに貢献して参ります。また、引き続き、この取り組みに賛同するSaaS事業者を募り、より質の高いソリューションの創出に尽力して参ります。</p>
        <h2>インハウスAI動画編集クラウド「VIDEO BRAIN」の特徴</h2>
        <p>説明会資料やオフィス写真など手持ちの素材をアップロードするだけで、誰でも簡単に企業紹介動画などを編集することができるクラウドサービスです。AIのサポートでテキストの要約や画像とのマッチング、そしてテロップ反映がされるので、ユーザーはライトな修正を加えるだけでクオリティの高い動画が簡単に作成できます。作成した動画は共有URLを通じて社内外の関係者へ送ることができ、確認作業も容易です。</p>
        <p>また、スピーチダイジェスト機能(β版)では、プレゼンテーションなど音声付きの動画をアップロードすると自動で書き起こしとテロップ反映がされ、必要なパートをピックアップするだけでダイジェスト動画の作成が可能です。社員インタビューなどをテロップ付きの動画をオンライン説明会をはじめとする採用活動で活用することができます。</p>

        <h2>オンライン説明会支援キャンペーン</h2>
        <p>2020年3月31日(火)までに、新規で「インタビューメーカー」と「VIDEO BRAIN」の両サービスをお申し込みの企業に対して、30秒程度の企業紹介動画1本の作成をサポート致します。</p>
        <p>静止画素材数点と紹介文、企業ロゴなどをご契約のVIDEO BRAINアカウントにアップロードすると、オープンエイトのオペレーターが企業紹介動画を作成をサポート。完成した動画は、そのままダウンロードして活用頂けるほか、素材を追加したりテロップを編集するなどいつでも自由に編集することができます。</p>

        <h2>スタジアム会社概要</h2>
        <p>スタジアムは、「面接×テクノロジー」のオンライン面接システム「インタビューメーカー」によって、面接とテクノロジーの融合を進め、従来では得られなかった価値や気づきを面接参加者に提供し、その利便性も大幅に高めていきます。対面面接をオンラインへ切り替えることにとどまらず、面接官向けのクラウド研修サービス「imトレーナー」や、面接特化型AI文字起こしサービス「imアシスタント」なども提供し、選考プロセス全体にテクノロジーの適用範囲を広げることで、さらなる大きな変革を目指します。「インタビューメーカー」は、国内導入社数1,100社を突破し、2020年度2月に日本マーケティングリサーチ機構による調査で、Web面接ツールで顧客満足度No.1を5部門で獲得しています。</p>
        <p class="no-indent">
          <span style="display: inline-block; min-width: 5em;">代表者</span>： <span style="display: inline-block;">代表取締役 兼 CEO　太田 靖宏</span><br />
          <span style="display: inline-block; min-width: 5em;">本社所在地</span>： <span style="display: inline-block;">東京都港区赤坂3-4-3　赤坂マカベビル6F</span><br />
          <span style="display: inline-block; min-width: 5em;">設立</span>： <span style="display: inline-block;">2012年8月</span><br />
          <a href="https://stadium.co.jp/">https://stadium.co.jp/</a>　（コーポレートサイト）<br />
          <a href="https://pray-for-wuhan.interview-maker.jp" target="_blank" rel="noopener">https://pray-for-wuhan.interview-maker.jp</a>　（サービスサイト）
        </p>

        <h2>オープンエイト会社概要</h2>
        <p>オープンエイトは、自然言語処理とコンピュータービジョンを中心とした独自のAI技術を活用し、アルゴリズム・ソフトウェアモジュール群からなる"OPEN8 CORE TECHNOLOGY"を保有するコンテンツテクノロジーカンパニーです。動画広告事業ならびに動画メディア事業で培った動画コンテンツ制作・配信ノウハウと、AI技術を組み合わせて開発したインハウスAI動画編集クラウド「VIDEO BRAIN」や動画生成機能などのAPI提供を通じて、企業による情報発信の支援を行っており、2019年には米 Red Herring社がアジアにおける革新的なベンチャー企業に贈る「2019 Red Herring Top 100 Asia Winner」を受賞しています。「AI×SaaSであらゆる企業の情報流通戦略の成長ドライバーとなる」ことを事業コンセプトに、以下の3事業を展開しています。</p>

        <h3>(1) SaaS事業</h3>
        <p>企業向けに、インハウスAI 動画編集クラウド「VIDEO BRAIN（ビデオブレイン）」の提供を行っています。</p>
        <p>写真やテキストなどの素材を入稿すると、AI エンジンが入稿データを分析し、動画の尺やサイズ、文言などを希望にあわせて調整するだけで、数分でリッチな動画コンテンツを編集することができます。大手企業をはじめ多数の企業が導入し、PRやマニュアル、営業資料など様々な業種・職種で広く活用されています。</p>

        <h3>(2)API事業</h3>
        <p>アルゴリズム・ソフトウェアモジュール群からなる"OPEN8 CORE TECHNOLOGY"をAPIで提供する事業です。単体での利用はもちろん複数の技術を組み合わせた利用もでき、企業のニーズに合わせて使い分けることが可能です。</p>

        <h3>(3)MLaaS（Machine Learning as a Service）事業</h3>
        <p>企業が保有するプライベートデータを基に独自のモデルを構築し、"OPEN8 CORE TECHNOLOGY"と組み合わせてオリジナルソリューションの開発を行います。</p>

        <p class="no-indent">
          株式会社オープンエイト<br />
          <span style="display: inline-block; min-width: 5em;">代表者</span>： <span style="display: inline-block;">代表取締役社長 兼 CEO　髙松雄康</span><br />
          <span style="display: inline-block; min-width: 5em;">本社所在地</span>： <span style="display: inline-block;">東京都渋谷区桜丘町20-1　渋谷インフォスタワー19階</span><br />
          <span style="display: inline-block; min-width: 5em;">設立</span>： <span style="display: inline-block;">2015年4月10日</span><br />
          <span style="display: inline-block; min-width: 5em;">事業内容</span>： <span style="display: inline-block;">SaaS事業・API事業・MLaaS事業</span><br />
          <a href="https://open8.com/" target="_blank" rel="noopener">https://open8.com/</a>
        </p>

        <h2>本件に関するお問い合わせ先</h2>
        <p class="no-indent">
          株式会社スタジアム　広報担当　布施<br />
          <span style="display: inline-block; min-width: 2.4em;">TEL</span>： <a href="tel:03-5797-7179">03-5797-7179</a><br />
          <span style="display: inline-block; min-width: 2.4em;">携帯</span>： <a href="tel:050-1744-4329">050-1744-4329</a><br />
          <span style="display: inline-block; min-width: 2.4em;">MAIL</span>： <a href="mailto:pr@stadium.co.jp">pr@stadium.co.jp</a>
        </p>

        <p class="no-indent">
          株式会社オープンエイト　広報担当　岩間・加藤<br />
          <span style="display: inline-block; min-width: 2.4em;">TEL</span>： 050-1749-7880<br />
          <span style="display: inline-block; min-width: 2.4em;">FAX</span>： 03-6892-5529<br />
          <span style="display: inline-block; min-width: 2.4em;">MAIL</span>： info@open8.com
        </p>
      `,
    },
    {
      id: 52,
      category: Category.Media,
      updatedAt: "2020/02/26",
      title:
        "メ～テレ（名古屋テレビ）「アップ」にて、「im」をご紹介いただきました",
    },
    {
      id: 53,
      category: Category.Media,
      updatedAt: "2020/02/26",
      title:
        "共同通信海外版（Kyodo News）にて、「im」無償提供の取り組みが紹介されました",
      href:
        "https://english.kyodonews.net/news/2020/02/579e0b189527-virus-outbreak-prompts-some-japan-firms-to-recruit-online.html",
    },
    {
      id: 54,
      category: Category.News,
      updatedAt: "2020/02/27",
      title:
        "企業の「採用活動や就職活動のオンライン化」に必要なサポートをジェイック社と共同で開始",
      href: "https://prtimes.jp/main/html/rd/p/000000030.000015527.html",
    },
    {
      id: 55,
      category: Category.News,
      updatedAt: "2020/03/03",
      title:
        "オンライン面接システム「インタビューメーカー」顧客満足度などの5部門でNo.1を達成！",
      href: "https://prtimes.jp/main/html/rd/p/000000031.000015527.html",
    },
    {
      id: 56,
      category: Category.News,
      updatedAt: "2020/03/03",
      title: "新型コロナウイルスの感染拡大に伴う影響調査の第二回結果を公開",
      href: "https://prtimes.jp/main/html/rd/p/000000032.000015527.html",
    },
    {
      id: 57,
      category: Category.Media,
      updatedAt: "2020/03/04",
      title:
        "インタビューメーカー導入企業のコープさっぽろ様が「北海道新聞」で紹介されました！",
      href: "https://www.hokkaido-np.co.jp/article/398841",
    },
    {
      id: 58,
      category: Category.Media,
      updatedAt: "2020/03/05",
      title:
        "ダイヤモンド・オンラインにて、インタビューメーカーの取り組みをご紹介いただきました！",
      href: "https://diamond.jp/articles/amp/230794?skin=amp",
    },
    {
      id: 59,
      category: Category.Media,
      updatedAt: "2020/03/09",
      title: "日経クロステックにて、インタビューメーカーが紹介されました",
      href: "https://xtech.nikkei.com/atcl/nxt/column/18/01223/022800002/",
    },
    {
      id: 60,
      category: Category.Media,
      updatedAt: "2020/03/10",
      title: "東洋経済オンラインにて、弊社の取り組みをご紹介いただきました！",
      href: "https://toyokeizai.net/articles/-/335280",
    },
    {
      id: 61,
      category: Category.Media,
      updatedAt: "2020/03/10",
      title: "日経クロステックにて、弊社の取り組みをご紹介いただきました！",
      href: "https://xtech.nikkei.com/atcl/nxt/column/18/00001/03715/",
    },
    {
      id: 62,
      category: Category.Media,
      updatedAt: "2020/03/16",
      title:
        "NHK「おはよう日本」にて、インタビューメーカーが取り上げられました！",
    },
    {
      id: 63,
      category: Category.News,
      updatedAt: "2020/03/18",
      title:
        "最大1,000名まで同時配信可能なオンライン説明会機能をリリースしました！",
      href: "https://prtimes.jp/main/html/rd/p/000000033.000015527.html",
    },
    {
      id: 64,
      category: Category.News,
      updatedAt: "2020/03/18",
      title:
        "リクルートキャリアと業務提携。リクナビ掲載企業に、オンライン説明会と面接機能を提供します。",
      href: "https://prtimes.jp/main/html/rd/p/000000034.000015527.html",
    },
    {
      id: 65,
      category: Category.News,
      updatedAt: "2020/03/26",
      title: "最大200名まで対応のオンライン会社説明会機能も無償開放開始",
      href: "https://prtimes.jp/main/html/rd/p/000000035.000015527.html",
    },
    {
      id: 66,
      category: Category.News,
      updatedAt: "2020/04/07",
      title: "オンラインでの面接実行数がわずか2ヶ月で15倍に急増",
      href: "https://prtimes.jp/main/html/rd/p/000000036.000015527.html",
    },
    {
      id: 67,
      category: Category.Media,
      updatedAt: "2020/04/19",
      title: "琉球新報にて、インタビューメーカーが取り上げられました",
      href: "https://ryukyushimpo.jp/news/entry-1109598.html",
    },
    {
      id: 68,
      category: Category.Media,
      updatedAt: "2020/04/22",
      title:
        "IT人材ラボに、インタビューメーカーについての記事が掲載されました！",
      href: "https://itjinzai-lab.jp/article/detail/2107",
    },
    {
      id: 69,
      category: Category.News,
      updatedAt: "2020/04/27",
      title:
        "月額制リファレンスチェックサービス『back check』のシステム連携機能を2020年夏をめどに提供開始します",
      href: "https://prtimes.jp/main/html/rd/p/000000037.000015527.html",
    },
    {
      id: 70,
      category: Category.News,
      title:
        "採用面接を科学的に追求する「JIRC(日本インタビューリサーチセンター)」を設立しました",
      updatedAt: "2020/05/01",
      body: `
      <p>
        Web面接・録画面接システム導入社数1,100社突破の
        「インタビューメーカー」を提供する株式会社スタジアムは、
        「JIRC（日本インタビューリサーチセンター）、所長 岩田 庸裕」
        を設立いたします。
      </p>
      <p>
        「キャリア人生をより豊かに」というミッションを掲げ、
        キャリアデザインに強い大学教授の方々と協力しながら
        人材の流動化が急速に進む日本においてミスマッチなく採用、
        面接が行われる世の中を実現し、日本経済の活性化に繋げることを目的に活動します。
      </p>
      <p class="no-indent">
        ■プレスリリースはこちら<br>
        <a href="https://prtimes.jp/main/html/rd/p/000000038.000015527.html" target="_blank" rel="noopener">https://prtimes.jp/main/html/rd/p/000000038.000015527.html</a>
      </p>
      `,
    },
    {
      id: 71,
      category: Category.News,
      title:
        "インタビューメーカーが採用管理システム「HITO-Link リクルーティング」と連携開始しました！",
      updatedAt: "2020/05/11",
      body: `
      <p>
        株式会社スタジアムが提供するWeb面接・録画面接システム「インタビューメーカー」と、総合人材サービス・パーソルグループのパーソルプロセス&テクノロジー株式会社が提供する新卒・中途採用支援システム「HITO-Link（ヒトリンク）リクルーティング」との連携を2020年3月より開始したことをお知らせいたします。本連携により、企業はリクルーティングにおける応募、面接、内定、承諾までを一括管理できるようになります。
      </p>
      <p class="no-indent">
        ■連携概要<br>
        　Web面接システム「インタビューメーカー」と採用管理システム「HITO-Link リクルーティング」の連携により、各ツールを利用することで発生していた応募者管理から面接日の設定から実施までの入力作業が「HITO-Link リクルーティング」上で一元管理できるようになりました。
      </p>
      <p class="no-indent">
        ■プレスリリースはこちら<br>
        <a href="https://prtimes.jp/main/html/rd/p/000000039.000015527.html" target="_blank" rel="noopener">https://prtimes.jp/main/html/rd/p/000000039.000015527.html</a>
      </p>
      `,
    },
    {
      id: 72,
      category: Category.News,
      title:
        "オンライン面接システム「インタビューメーカー」導入社数2,700社を突破",
      updatedAt: "2020/05/28",
      body: `
      <p class="no-indent">
        ■Web面接・録画面接システム「インタビューメーカー」について<br>
        　スタジアムの採用特化型オンライン面接システム『インタビューメーカー』は、"世界中で人と企業が繋がる機会を提供する"ことを目指し、2016年よりサービス提供を開始いたしました。2020年5月現在、国内2,700社を超える企業の様々な採用シーンで活用いただいております。
      </p>

      <p class="no-indent">
        　『インタビューメーカー』は、企業における採用業務の効率化や、応募者にとっての平等な機会を提供することのみならず、AIなどの最新テクノロジーを活用し、採用現場の音声や映像、文字情報を徹底的に可視化し、分析を進めることで、採用活動の属人化やブラックボックス化の解消を進めています。<br>
        　従来の"安心して使えるオンライン面接システム"という役割から、"面接をデザインするシステム"へと役割をシフトすることで、企業における優秀な人材獲得の機会、そして応募者にとっても人生の重要な意思決定の場面となる採用面接の質を向上させ、最良の出会いを実現することに貢献してまいります。
      </p>
      <p class="no-indent">
        プレスリリース詳細はこちら<br>
        <a href="https://prtimes.jp/main/html/rd/p/000000040.000015527.html" target="_blank" rel="noopener">https://prtimes.jp/main/html/rd/p/000000040.000015527.html</a>
      </p>
      `,
    },
    {
      id: 73,
      category: Category.Media,
      title:
        "日本金融通信社「ニッキン」5月29日号でインタビューメーカーが取り上げられました！",
      updatedAt: "2020/05/29",
      body: `
      <p class="no-indent">
        金融総合情報機関である日本金融通信社「ニッキン」の5月29日号で、インタビューメーカーを取り上げていただきました。
      </p>
      <p class="no-indent">
        詳細はこちら<br>
        <a href="https://www.nikkin.co.jp/" target="_blank" rel="noopener">https://www.nikkin.co.jp/</a>
      </p>
      `,
    },
    {
      id: 74,
      category: Category.News,
      title:
        "「インタビューメーカー」が、スタッフ採用管理システム「RPM」と連携開始しました！",
      updatedAt: "2020/06/16",
      body: `
      <p>
        株式会社スタジアム（本社：東京都港区、代表取締役社長兼CEO 太田 靖宏、以下「スタジアム」）が提供するWeb面接・録画面接システム「インタビューメーカー」と、株式会社ゼクウ(本社：東京都港区、代表取締役社長：当摩 武彦)が提供する派遣スタッフ採用管理支援システム「RPM」との連携を2020年5月より開始したことをお知らせいたします。本連携により、企業はリクルーティングにおける応募、面接、内定、承諾までを一括管理できるようになります。
      </p>
      <p class="no-indent">
        詳細はこちら<br>
        <a href="https://prtimes.jp/main/html/rd/p/000000042.000015527.html" target="_blank" rel="noopener">https://prtimes.jp/main/html/rd/p/000000042.000015527.html</a>
      </p>
      `,
    },
    {
      id: 75,
      category: Category.Media,
      title:
        "企業で働くクリエイター向けサイト「CreatorZine」に当社デザイナー家高のインタビューが掲載されました",
      updatedAt: "2020/06/26",
      body: `
      <p>
      企業で働くクリエイター向けサイト「CreatorZine」に当社デザイナー家高のインタビュー『toCからtoBへ「インタビューメーカー」のデザイナーがtoBだからこそ心がけていることとは』が掲載されました。
      スタジアムへの入社のきっかけやtoBデザイナーの想いについてお話しさせていただいております。ぜひご覧ください。
      </p>
      <blockquote style="border-left: 4px solid #e8e8e8; padding-left: 1em;">
        先日、導入社数が2,700社を突破した株式会社スタジアムが開発・提供する「インタビューメーカー」。複数人面接にも対応したWeb面接、自己アピール動画の提出も可能な録画面接、説明会／セミナー開催、面接官のクラウド研修、適性検査「SPI-3連携」、各種採用管理システムとの連携、オンライン合同会社説明会の開催など、さまざまな機能を提供しているWeb面接・録画面接システムだ。今回は、そんなインタビューメーカーのデザイナー・家高秀樹さんに話を聞いた。ウェブ制作会社、C向けのサービスを展開する事業会社を経て、B向けのサービスへとたどり着いた家高さんの経緯や、企業が使うサービスだからこそ意識していることとは。
      </blockquote>
      <p class="no-indent">
      ■詳細は<a href="https://creatorzine.jp/article/detail/1103" target="_blank" rel="noopener">こちら</a>
      </p>
      `,
    },
    {
      id: 76,
      category: Category.Media,
      title:
        "就活をテーマにしたラジオ番組『#好きに就活 「好き」に進もう羅針盤ラジオ』に、当社の鳥越がゲストとして出演しました！",
      updatedAt: "2020/06/26",
      body: `
      <p>
        就活をテーマにしたラジオ番組『#好きに就活 「好き」に進もう羅針盤ラジオ』に、当社インタビューメーカー事業本部の鳥越が、スペシャルゲストとして出演させていただきました。<br><br>
        ●Web面接のとき、面接官ってどんな気持ちなの？<br>
        ●Web面接のときのカンペテクニックとは！？<br>
        ●Wi-Fiと4Gってどっちが良い？<br>
        ●Web上でのグループワークってどんなところを見ている？<br>
        ●面接官側のWeb面接のメリットとは・・・<br><br>
        等、様々な質問についてお話させていただきました。是非ご視聴ください。
      </p>
      <p class="no-indent">
        ■番組視聴は<a href="https://park.gsj.mobi/voice/show/20780" target="_blank" rel="noopener">こちら</a><br>
        ■Spotifyでもご視聴いただけます。ご視聴は<a href="https://open.spotify.com/episode/35ZF38bm3wNMcChCOML0te" target="_blank" rel="noopener">こちら</a>
      </p>
      `,
    },
    {
      id: 77,
      category: Category.News,
      title:
        "リクルートジョブズ、リクルートキャリアと協働開始。「タウンワーク」など６つの求人媒体を通じ、Web面接機能を90日間無料で提供いたします。",
      updatedAt: "2020/07/01",
      body: `
      <p>
        Web面接・録画面接システム「インタビューメーカー」を提供する株式会社スタジアム（東京都港区、代表取締役：太田 靖宏　以下当社）は、面接をオンライン化したい企業さまの支援のため、「タウンワーク」などを提供する株式会社リクルートジョブズ（本社：東京都中央区、代表取締役社長：酒井 久典）、「リクナビNEXT」などを提供する株式会社リクルートキャリア（本社：東京都千代田区、代表取締役社長：佐藤 学）と連携したサービスを開始いたしました。
      </p>
      <p>
        この協働によって、株式会社リクルートジョブズ、株式会社リクルートキャリアの提供する求人媒体（タウンワーク、フロム・エー ナビ、はたらいく、とらばーゆ、リクナビ派遣、リクナビNEXT）掲載企業は、インタビューメーカーが提供するWeb面接やオンライン会社説明会の機能を最大90日間無料（2020/7/1～2020/9/30まで）で利用可能になります。
      </p>
      <p class="no-indent">
        ■詳細は<a href="https://prtimes.jp/main/html/rd/p/000000044.000015527.html" target="_blank" rel="noopener">こちら</a>
      </p>
      `,
    },
    {
      id: 78,
      category: Category.Media,
      title:
        "インタビューメーカーを導入いただいている北海道警察様が、メディアで取り上げられました！",
      updatedAt: "2020/07/07",
      body: `
      <p>
        インタビューメーカーをご導入いただいている北海道警察様が、メディアに取り上げられました。北海道警察様は、弊社のインタビューメーカーの機能を利用して、Webグループ説明会を実施されています。Webを通じての説明会を実施するのは、北海道警察様が全国で初めてとのことです。
      </p>
      <p>
        詳細は<a href="https://www.asahi.com/articles/ASN756SYXN75IIPE00D.html" target="_blank" rel="noopener">こちら</a>
      </p>
      `,
    },
    {
      id: 79,
      category: Category.News,
      title:
        "ツナグ・ソリューションズ様のサイトにて、当社執行役員の熊本と前澤がゲストの対談記事が掲載されました！",
      updatedAt: "2020/07/17",
      body: `
        <p>
          対談やインタビュー等を通じて、採用活動成功の秘訣を探る「Beyond the 2020」にて、株式会社ツナグ・ソリューションズの玉井生様と、当社執行役員の熊本と前澤がゲストとして対談を行い、その対談記事が掲載されました。
        </p>
        <p>
          対談記事は<a href="https://www.tsunagu.co.jp/library/0004" target="_blank" rel="noopener">こちら</a>
        </p>
        <blockquote>
          <p>
            －Beyond the 2020－テクノロジーで質の向上を目指す『Web面接』の未来
          </p>
          <p>
            コロナウイルスの感染拡大・多数の労働に関する法改正など採用市場はより複雑化、そしてより不透明な状況である。ツナグ・ソリューションズでは「Beyond the 2020」と称し、対談やインタビュー等を通じて、採用活動成功の秘訣を探ります。
          </p>
          <p>
            今回のゲストは、「面倒な面接スケージュールを自動で調整したい」「応募者情報や選考中の情報を社内に共有したい」「初めての動画面接で上手く導入できるか不安」そんなお悩みを解決するWeb面接特化型システム「インタビューメーカ－」を運営する株式会社スタジアム執行役員熊本康孝氏、前澤隆一郎氏です。
          </p>
        </blockquote>
        <p class="no-indent">
          <img src='${require("@/pr-assets/20200717/img_tsunagu_talk.jpg")}' alt="" style="max-width: 100%;" />
        </p>        
      `,
    },
    {
      id: 80,
      category: Category.News,
      title:
        "「インタビューメーカー」が「ジョブスイート」シリーズと連携開始しました！",
      updatedAt: "2020/07/20",
      body: `
        <p>
          株式会社スタジアム（本社：東京都港区、代表取締役兼CEO太田靖宏、 以下「スタジアム」）が提供するWeb面接・録画面接システム「インタビューメーカー」と、 株式会社ステラスJPOSTING事業部（本社：東京都千代田区、代表取締役社長：戸村敦雄）が提供する「ジョブスイート」シリーズは連携を2020年7月より開始したことをお知らせいたします。 本連携により、企業はリクルーティングにおける応募、面接、内定、承諾までを一括管理できるようになります。
        </p>
        <p>
          詳細は<a href="https://prtimes.jp/main/html/rd/p/000000043.000015527.html" target="_blank" rel="noopener">こちら</a>
        </p>
        <p>
        <img src='${require("@/pr-assets/pr_jobsuite.png")}' alt="" style="max-width: 100%;" />
        </p>
      `,
    },
    {
      id: 81,
      category: Category.Media,
      title:
        "「月刊アミューズメントジャパン」8月号にて、インタビューメーカーを紹介いただきました！",
      updatedAt: "2020/07/20",
      body: `
        <p>
        パチンコ業界誌「月刊アミューズメントジャパン」8月号にて、Web面接システム「インタビューメーカー」をご紹介いただきました。
        </p>
        </br>
        <blockquote>
        <p>
        「広がるWeb面接の活用 対面との併用がスタンダードに」</br>
        新型コロナウイルス対策の特別措置法にに基づく緊急事態宣言の発令によって、21年卒採用出はWeb面接が一気に広まった。 必要に迫られて始めた企業が大半だが有用性の高さから今後の採用活動でも定着することは必至。採用新時代に備えて導入を検討してみる必要がありそうだ。
        </p>
        </blockquote>
        </br>
        <p>
        <iframe src="https://public.stdm.us/news/20200720134723804.pdf" width="900" height="750"></iframe>
        </p>
        <p>
        
        </p>
      `,
    },
    {
      id: 82,
      category: Category.News,
      title: "インタビューメーカー初のTVCM「こうみえて」編が公開されました！",
      updatedAt: "2020/07/22",
      body: `
        <p>
        7/17(金)より、インタビューメーカーは初のテレビCMを公開しました！
        CMには、「こうみえてA」「こうみえてB」の2パターンがあります。
        </p>
        <p>
        今回のCMには、俳優の田中穂先さんと小泉将臣さんにご出演いただきました。</br>
        「面接で人を見抜くことの難しさ」をテーマとして、お2人の演技力が光る、ユーモアあふれるCMとなっています。</br>
        是非一度ご覧ください。
        </p>
      `,
    },
    {
      id: 83,
      category: Category.News,
      title:
        "オンライン面接の導入企業へ利用意向調査を実施。導入済の企業の89％が、次年度もWeb面接を併用する方針。",
      updatedAt: "2020/07/28",
      body: `
        <p>
        Web面接・録画面接システム導入社数2,700社突破の「インタビューメーカー」を提供する株式会社スタジアム（東京都港区、代表取締役 兼 CEO：太田 靖宏）は、Web面接・Web説明会の利用意向・実態を調査する目的で、利用企業向けにアンケートを実施いたしました。
        </p>
        調査結果から、今年度からWeb面接を導入した企業が72％、次年度以降もWeb面接を併用する意向を持っている企業が89％あることが判明しました。また、インタビューメーカー導入の決め手としては、「信頼できる取引先の紹介」「専用アプリ不要」「無料プラン活用」といった回答が上位を占めました。対面/Web面接の比較においては、応募者対応にかかる労力・事前準備・費用負担等の面において、対面よりWeb面接の方が優位に感じられるといった傾向が見られました。
        <p>
        詳細は<a href="https://prtimes.jp/main/html/rd/p/000000045.000015527.html" target="_blank" rel="noopener">こちら</a>
        <img src='${require("@/pr-assets/pr_main.png")}' alt="" style="max-width: 100%;" />
        </p>
      `,
    },
    {
      id: 84,
      category: Category.Media,
      title:
        "インタビューメーカー導入企業のパナソニック様のオンライン採用に関する記事が公開されました！",
      updatedAt: "2020/07/30",
      body: `
        <p>
        2020年の新卒採用で、インタビューメーカーをご利用いただいたパナソニック様の記事が公開されました。</br>
        パナソニック様は、2021年卒の新卒採用を100%オンラインに切り替えて対応し、最終選考まで一度も対面せずに採用活動を実施されました。
        </p>
        <p>
        コロナ渦における採用活動の裏側や「オンライン採用」という初の試みによる不安、準備、オンライン面接だからこその注意点などをリアルにお話されています。ぜひご覧ください！
        </p>
        <p>
        詳細は<a href="https://www.keyman.or.jp/kn/articles/2007/29/news021.html" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 85,
      category: Category.Media,
      title:
        "NHK「ニュースウオッチ9」にてインタビューメーカーが紹介されました！",
      updatedAt: "2020/08/11",
      body: `
        <p>
        2020年8月7日21時放送のNHK「ニュースウオッチ9」にて、インタビューメーカーが紹介されました。企業の採用活動のオンライン化が進む中、大学でも入試をオンライン化したいというニーズが高まっています。
        </p>
        <p>
        その中で、既に約100大学と商談を進め、12大学の入試に導入いただくことが決定している当社に、大学入試のオンライン化の現状を取材いただきました。
        </p>
        <p>
        NHK「ニュースウオッチ9」のページは<a href="https://www.nhk.jp/p/nw9/ts/V94JP16WGN/" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 86,
      category: Category.Media,
      title:
        "日本テレビ「天才！！カンパニー」にて、インタビューメーカーをご紹介いただきました！",
      updatedAt: "2020/08/15",
      body: `
        <p>
        2020年8月15日放送の日本テレビ情報番組「天才！！カンパニー」にて、インタビューメーカーをご紹介いただきました。</br>
        おぎやはぎの矢作さん、東京03の飯塚さん、北陽の虻川さんが、実際にインタビューメーカーを使いながら、その魅力についてご紹介いただいています。</br>
        公式YouTubeチャンネルにも掲載いただいているので、是非ご覧ください！
        </p>
        <p>
        「天才！！カンパニー」公式HPは<a href="https://www.ntv.co.jp/tensai/" target="_blank" rel="noopener">こちら</a>
        </p>
        <p>
        8月15日放送の動画は<a href="https://www.youtube.com/watch?v=xal7t1zbzlc&list=PLo7nw2x6bhE9i2OxhKUg3GK9WesAj9ITG&index=2&t=187s" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 87,
      category: Category.Media,
      title:
        "週刊東洋経済プラス「すごいベンチャー100」にて、当社「インタビューメーカー」が選出されました！",
      updatedAt: "2020/08/17",
      body: `
        <p>
        週刊東洋経済プラス「すごいベンチャー100」の人事サービス部門にて、当社「インタビューメーカー」が選出されました。
        </p>
        <p>
        <blockquote>
        活況を呈していたベンチャー投資市場は、コロナショックによって一変。明暗がくっきり分かれている。</br>
        例えば観光・レジャーなど「人の移動」に関わるようなベンチャー企業は大苦戦。その一方で「非接触」「非対面」へのニーズが急上昇している。再生可能エネルギー関連や暗号資産などの金融テクノロジーにも元気な企業が多い。</br>
        本特集では、ウィズコロナ、アフターコロナ時代に飛躍するベンチャー企業を厳選。「昨年までのベンチャー100特集に選ばれていない」という条件をクリアしている企業だけを掲載しており、ニューフェイスばかりだ。
        </blockquote>
        </p>
        <p>
        掲載ページは<a href="https://premium.toyokeizai.net/articles/-/24390" target="_blank" rel="noopener">こちら</a>
        </p>
        <div class="iframe-wrap">
　      <iframe src="https://public.stdm.us/news/202008271940.pdf" frameboader="0"></iframe>
        </div>
      `,
    },
    {
      id: 88,
      category: Category.Media,
      title: "Findyに当社のインタビュー記事が掲載されました！",
      updatedAt: "2020/08/24",
      body: `
        <p>
        Findyに、当社のインタビュー記事『面接を科学するーWeb面接システム「インタビューメーカー」を提供するスタジアムがテクノロジーで目指すものとは』が掲載されました。
        </p>
        <p>
        <blockquote>
        Web面接特化型システム「インタビューメーカー」を提供する、株式会社スタジアム。コロナ禍におけるオンライン採用が注目を集める中、「インタビューメーカー」は現在2,700社を超える企業に導入されています。</br>
        今回、取締役の間渕紀彦さんとCTOの武田慎之介さんの2名にインタビューを実施。スタジアムの目指す事業やエンジニア組織、そしてエンジニアから見たスタジアムの魅力についてお話いただきました。
        </blockquote>
        </p>
        掲載ページは<a href="https://findy-code.io/interviews/stadium-engineer" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 89,
      category: Category.Media,
      title: "週刊エコノミストに、弊社代表太田のインタビューが掲載されました！",
      updatedAt: "2020/08/24",
      body: `
        <p>
        週刊エコノミストに当社代表太田のインタビュー記事『太田靖宏 スタジアム代表取締役 技術で作り出す新時代の面接』が掲載されました。
        代表の太田がインタビューメーカー開発の経緯や今後の展開について話しています。
        </p>
        <p>
        掲載ページは<a href="https://weekly-economist.mainichi.jp/articles/20200825/se1/00m/020/058000c" target="_blank" rel="noopener">こちら</a>
        </p>
        <div class="iframe-wrap">
        　<iframe src="https://public.stdm.us/news/200825_weekly-economist.pdf" frameboader="0"></iframe>
        </div>
      `,
    },
    {
      id: 90,
      category: Category.Media,
      title: "@ITに当社CTO武田の寄稿記事が掲載されました！",
      updatedAt: "2020/08/28",
      body: `
        <p>
        ITエキスパートのための問題解決メディア「@IT」の特集「ポストコロナのITサバイバル術」にて、弊社CTO(最高技術責任者)である武田の寄稿記事「代替可能なエンジニアのポストコロナ生き残り術」が掲載されました。
        </p>
        <p>
        ポストコロナで生き残るのはどんなエンジニアなのか、また必要とされるエンジニアになるための要素について意見を述べています。</br>
        是非ご覧ください。
        </p>
        <p>
        掲載ページは<a href="https://www.atmarkit.co.jp/ait/articles/2008/28/news004.html" target="_blank" rel="noopener">こちら</a>
      `,
    },
    {
      id: 91,
      category: Category.Media,
      title:
        "「PR TIMES STORY」に、当社執行役員の前澤が執筆した記事が掲載されました！",
      updatedAt: "2020/08/28",
      body: `
        <p>
        行動者のストーリー・ナラティブ(物語)を届けるメディア「PR TIMES STORY」に、当社執行役員の前澤が執筆した記事が掲載されました。
        </p>
        <p>
        タイトルは、『新型コロナウイルスへの対応で、Web面接システムの無償提供を最速で実現できた訳』で、im無償提供の決断に至る背景・経緯から2,800社に導入いただけるようになるまでの一連の流れが克明に描かれています。
        </p>
        <p>
        掲載ページは<a href="https://prtimes.jp/story/detail/0bKkagiRRbW" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 92,
      category: Category.Media,
      title:
        "フォーム作成ツール「formrun」の導入事例ページで、当社のインタビュー記事が公開されました！",
      updatedAt: "2020/09/18",
      body: `
        <p>
        フォーム作成ツール「formrun」導入事例ページで、当社のインタビュー記事『Slack通知やGoogleスプレッドシートの自動出力機能で生産性の向上を追求！「formrunはあまりにも便利すぎる」と唸った背景とは⁉︎』が公開されました。</br>
        当社執行役員の前澤が、formrunの活用方法やおすすめの機能について話しています。
        </p>
        <p>
        掲載ページは<a href="https://form.run/media/cases/stadium/" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 93,
      category: Category.Media,
      title: "「宣伝会議」に弊社代表太田のインタビューが掲載されました",
      updatedAt: "2020/10/01",
      body: `
        <p>
        月刊宣伝会議に当社代表太田のインタビュー記事『社長、どうしてCMはじめたんですか？』が掲載されました。
        </p>
        <p>
        太田がインタビューメーカーのテレビCMを打った目的、経緯の詳細について話しています。
        </p>
      `,
    },
    {
      id: 94,
      category: Category.Media,
      title: "「ブレーン」に弊社執行役員前澤のインタビューが掲載されました",
      updatedAt: "2020/10/01",
      body: `
        <p>
        月刊ブレーンに弊社執行役員前澤のインタビュー記事『心に残ったプレゼン術』が掲載されました。 
        </p>
        <p>
        前澤がインタビューメーカーのCMクリエイティブが完成するまでの経緯について、クリエイティブディレクターの山崎隆明さんとのやり取りを中心に話しています。
        </p>
      `,
    },
    {
      id: 95,
      category: Category.News,
      title:
        "「インタビューメーカー」が「アクセスオンライン」シリーズと連携開始しました！",
      updatedAt: "2020/10/12",
      body: `
        <p>
        株式会社スタジアム（本社：東京都港区、代表取締役社長兼CEO 太田 靖宏、以下「スタジアム」）が提供するWeb面接・録画面接システム「インタビューメーカー」と、株式会社マイナビ（本社：東京都千代田区、代表取締役社長：中川 信行）が提供する「ACCESS ON LINE」シリーズは連携を2020年1月より開始することをお知らせいたします。本連携により、企業はリクルーティングにおける応募、面接、内定、承諾までを一括管理できるようになります。
        </p>
        <p>
        詳細は<a href="https://prtimes.jp/main/html/rd/p/000000046.000015527.html" target="_blank" rel="noopener">こちら</a>
        </p>
        <p class="no-indent">
        <img src='${require("@/pr-assets/20201012/AOL.png")}' alt="" style="max-width: 100%" />
        </p>
      `,
    },
    {
      id: 96,
      category: Category.Media,
      title:
        "インタビューメーカー導入企業 味の素様のオンライン採用に関する記事が公開されました！",
      updatedAt: "2020/10/22",
      body: `
        <p>
        2020年の新卒採用で、インタビューメーカーをご利用いただいた味の素様の記事が公開されました。
        </p>
        <p>
        新型コロナウイルスの感染拡大で多くの部門の業務がオンラインに移行していく中、コロナ前からWeb面接に特化したツールを導入するなど、仕組みを整備してきた味の素様の新卒採用がどう変わったのか。また、Web面接ならではの難しさをどう克服しているのか。ぜひご覧ください。
        </p>
        <p>
        詳細は<a href="https://hrzine.jp/article/detail/2549" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 97,
      category: Category.News,
      title:
        "「インタビューメーカー」のテレビCMが、日本最大級のクリエイティブアワードで入賞しました！",
      updatedAt: "2020/11/02",
      body: `
        <p>
        株式会社スタジアム（本社：東京都港区、代表取締役社長兼CEO 太田 靖宏、以下「スタジアム」）が提供するWeb面接システム「インタビューメーカー」初のテレビCM「こう見えて篇A・B」(広告会社：電通/ワトソン・クリック、制作会社：春企画東京)が、「2020 60th ACC TOKYO CREATIVITY AWARDS」（主催：一般社団法人ACC）において評価され、フィルム部門Aカテゴリー(テレビCM)で “ACCシルバー” に入賞しました。
        </p>
        <p>
        詳細は<a href="https://prtimes.jp/main/html/rd/p/000000047.000015527.html" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 98,
      category: Category.Media,
      title: "「週刊ダイヤモンド」に執行役員前澤のコメントが掲載されました",
      updatedAt: "2020/11/06",
      body: `
        <p>
        週刊ダイヤモンドに、弊社執行役員前澤のコメントが掲載されました。
        </p>
        <p>
        11/7号特集「オンライン新卒採用3つの秘技とは？」内、「応募者の不安を解消する採用時の3つのポイント」に掲載されています。
        </p>
      `,
    },
    {
      id: 99,
      category: Category.Media,
      title: "「キーマンズネット」に当社のインタビュー記事が掲載されました",
      updatedAt: "2020/11/09",
      body: `
        <p>
        「キーマンズネット」に、当社のインタビュー記事が掲載されました。連載企画「IT導入完全ガイド」内の「オンライン面接で応募者の心をつかむには？Web面接ツールでできること、起こりがちなトラブルとは」というタイトルにて、「採用活動のオンラインシフトに向けてオンライン面接で応募者を引き付けるにはどうすればいいか？」「起こりがちなトラブルとは？」等のテーマについて解説しています。
        </p>
        <p class="no-indent">
        詳細は<a href="https://www.keyman.or.jp/kn/articles/2011/09/news021.html" target="_blank" rel="noopener">こちら</a><br />
        ※記事全文を閲覧いただくためには、アイティメディアIDのご登録が必要になります。
        </p>
      `,
    },
    {
      id: 100,
      category: Category.Media,
      title: "「HRzine」に当社貝洲の寄稿記事が掲載されました",
      updatedAt: "2020/11/12",
      body: `
        <p>
        「HRzine」に、当社マーケティング部・貝洲(かいす)の寄稿記事「知っておきたい！ Web面接で失敗しないための実践的ノウハウ」が掲載されました。Web面接の事前準備から後対応まで、企業が導入・実施する上で役に立つノウハウ、注意すべきポイント等について、事例を踏まえてまとめています。
        </p>
        <p class="no-indent">
        詳細は<a href="https://hrzine.jp/article/detail/2657" target="_blank" rel="noopener">こちら</a><br />
        ※記事全文を閲覧いただくためには、会員登録が必要になります。
        </p>
      `,
    },
    {
      id: 101,
      category: Category.News,
      title:
        "「オンライン面接システムにおける就活生向けAI評価に関する共同プロジェクト」に参画いたします！",
      updatedAt: "2020/12/3",
      body: `
        <p>
          Web面接・録画面接システム「インタビューメーカー」を提供する株式会社スタジアムは、 「SENDAI X-TECH Innovation Project 2020」における「ニューノーマル時代のビジネス共創プログラム」の取り組みとして、 国立大学法人東北大学発のAIスタートアップ 株式会社Adonsons（アダンソンズ、 本社：宮城県仙台市、 代表取締役CEO：石井 晴揮）との「オンライン面接システムにおける就活生向けAI評価」に関する共同プロジェクトが開始されることをお知らせいたします。
        </p>
        <p class="no-indent">
        詳細は<a href="https://prtimes.jp/main/html/rd/p/000000048.000015527.html" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 102,
      category: Category.News,
      title: "「インタビューメーカー」が「i-web」と連携開始しました！",
      updatedAt: "2020/12/16",
      body: `
        <p>
          株式会社スタジアム（本社：東京都港区、代表取締役社長兼CEO 太田 靖宏、以下「スタジアム」）が提供するWeb面接・録画面接システム「インタビューメーカー」と、株式会社ヒューマネージ（本社：東京都千代田区、代表取締役社長：齋藤 亮三）が提供する「i-web」は連携を開始することをお知らせいたします。本連携により、企業はリクルーティングにおける応募、面接、内定、承諾までを一括管理できるようになります。
        </p>
        <p class="no-indent">
        詳細は<a href="https://prtimes.jp/main/html/rd/p/000000049.000015527.html" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 103,
      category: Category.News,
      title:
        "「インタビューメーカー」が「採用一括かんりくん」と連携開始しました！",
      updatedAt: "2020/12/23",
      body: `
        <p>
        株式会社スタジアムが提供するWeb面接・録画面接システム「インタビューメーカー」と、株式会社Rootsが提供する「採用一括かんりくん」は連携を開始することをお知らせいたします。本連携により、企業はリクルーティングにおける応募、面接、内定、承諾までを一括管理できるようになります。
        </p>
        <p class="no-indent">
        詳細は<a href="https://prtimes.jp/main/html/rd/p/000000050.000015527.html" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 104,
      category: Category.News,
      title: "「インタビューメーカー」が「e2R PRO」と連携開始しました！",
      updatedAt: "2020/12/25",
      body: `
        <p>
        株式会社スタジアムが提供するWeb面接・録画面接システム「インタビューメーカー」と、株式会社ワークス・ジャパンが提供する「e2R PRO」は連携を開始することをお知らせいたします。本連携により、企業はリクルーティングにおける応募、面接、内定、承諾までを一括管理できるようになります。        </p>
        <p class="no-indent">
        詳細は<a href="https://prtimes.jp/main/html/rd/p/000000051.000015527.html" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 105,
      category: Category.Media,
      title: "月刊人事マネジメントに掲載されました。",
      updatedAt: "2021/1/5",
      body: `
        <p>
        月刊人事マネジメントに当社マーケティング部・貝洲の寄稿記事『オンライン選考のメリットに要注目』が掲載されました。主に採用フローにおけるWeb化のメリットについて取り上げています。
        <p class="no-indent">
        記事は<a href="http://hrm-magazine.busi-pub.com/trends2101.html" target="_blank" rel="noopener">こちら</a>
        </p>
        <div class="iframe-wrap">
        <iframe src="https://public.stdm.us/202101HR-ShortMessage.pdf" frameboader="0"></iframe>
        </div>
      `,
    },
    {
      id: 106,
      category: Category.News,
      title: "ドコモ「AI電話サービス」を導入・販売パートナー連携開始",
      updatedAt: "2021/1/5",
      body: `
        <p>
        株式会社スタジアムが提供するWeb面接・録画面接システム「インタビューメーカー」は、株式会社NTTドコモが提供する「AI電話サービス」を、面接参加者向けのサポートデスク業務へ2020年3月を目標に導入し、合わせて、販売パートナーとなりましたことをお知らせします。
        <p class="no-indent">
        詳細は<a href="https://public.stdm.us/210105%20NTT%E3%83%89%E3%82%B3%E3%83%A2%E3%83%BB%E3%82%B9%E3%82%BF%E3%82%B8%E3%82%A2%E3%83%A0%E6%8F%90%E6%90%BA.pdf" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
    {
      id: 107,
      category: Category.Media,
      title: "「日本経済新聞電子版」に当社今井のインタビューが掲載されました",
      updatedAt: "2021/1/20",
      body: `
        <p>
        「日本経済新聞電子版」に、当社今井のインタビューが掲載されました。「就活探偵団」内の「21就活まるわかり　熱意どう伝達？オンライン面接編」というタイトルにて、オンライン面接突破のために必要なポイント・注意点等について解説しています。
        <p class="no-indent">
        詳細は<a href="https://www.nikkei.com/article/DGXZQODZ15BB60V10C21A1000000?unlock=1" target="_blank" rel="noopener">こちら</a><br>
        ※記事全文を閲覧いただくためには、日経IDのご登録が必要になります。
        </p>
      `,
    },
    {
      id: 108,
      category: Category.News,
      title: "インタビューメーカーが「ITreview Grid AWARD」で受賞",
      updatedAt: "2021/1/22",
      body: `
        <p>
        株式会社スタジアムが提供するWeb面接システム「インタビューメーカー」は、アイティクラウド株式会社が運営する「ITreview Grid AWARD 2021 Winter」にて、満足度と認知度が高い製品として、Web面接部門の「Leader」を受賞しました。
        <p class="no-indent">
        詳細は<a href="https://prtimes.jp/main/html/rd/p/000000052.000015527.html" target="_blank" rel="noopener">こちら</a>
        </p>
      `,
    },
  ];
}
